import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import { logout } from '@common/components/authentication/auth.thunks';
import { AppDispatch } from '@store/types';

const NAV_ITEMS = [{ label: 'Agents', path: '/agents', icon: <SmartToyOutlinedIcon /> }];

export const Navigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <Box
      sx={(theme) => ({
        width: 240,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        borderRight: `1px solid ${theme.palette.divider}`,
        bgcolor: 'background.default',
        flexShrink: 0,
      })}
    >
      <List sx={{ flex: 1, pt: 1 }}>
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname.startsWith(item.path);
          return (
            <ListItemButton
              key={item.path}
              onClick={() => navigate(item.path)}
              sx={(theme) => ({
                mx: 1,
                borderRadius: '8px',
                mb: 0.5,
                color: isActive ? '#39C88A' : theme.palette.text.secondary,
                background: isActive ? 'rgba(57,200,138,0.1)' : 'transparent',
                '&:hover': {
                  background: isActive ? 'rgba(57,200,138,0.15)' : theme.palette.action.hover,
                },
              })}
            >
              <ListItemIcon sx={{ color: 'inherit', minWidth: 36 }}>{item.icon}</ListItemIcon>
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{ fontSize: '0.875rem', fontWeight: isActive ? 600 : 400 }}
              />
            </ListItemButton>
          );
        })}
      </List>

      <Box
        sx={(theme) => ({
          p: 1,
          borderTop: `1px solid ${theme.palette.divider}`,
        })}
      >
        <Tooltip title="Logout" placement="right">
          <ListItemButton
            onClick={handleLogout}
            sx={{
              borderRadius: '8px',
              color: 'text.secondary',
              '&:hover': { background: 'rgba(239,68,68,0.1)', color: '#EF4444' },
            }}
          >
            <ListItemIcon sx={{ color: 'inherit', minWidth: 36 }}>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Logout" primaryTypographyProps={{ fontSize: '0.875rem' }} />
          </ListItemButton>
        </Tooltip>
      </Box>
    </Box>
  );
};
